/* istanbul ignore file -- Client app related file */

import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { WebMessengerController } from '@ori/web-messenger';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  globalApiUrl,
  graphqlUrl,
  graphqlNetUrl,
  identityUrl,
  staticApiUrl,
  tenant
}) => /*#__PURE__*/_jsx(ServiceUrlsProvider, {
  serviceUrls: {
    staticApiUrl,
    graphQlUrl: graphqlUrl,
    graphQlNetUrl: graphqlNetUrl,
    globalApiUrl,
    identityUrl
  },
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    tenant: tenant,
    children: /*#__PURE__*/_jsx(TranslationsProvider, {
      defaultTranslationsWithNamespaces: {},
      language: currentLanguage,
      translationsWithNamespaces: {},
      children: /*#__PURE__*/_jsx(WebMessengerController, {})
    })
  })
});